import row from './bf-row.vue';
row.install = Vue => Vue.component(row.name,row);
export default row;



// WEBPACK FOOTER //
// ./src/packages/grid/row/index.js